import React from 'react'
import { Button, Col } from 'reactstrap'
import queryString from 'query-string'
import { Link } from 'react-router-dom'

export default function ActionButton({ id, actionId, history, search }) {
  // creates a new query pointing to this action block
  let qs = queryString.parse(search)
  let newQuery = {
    ...qs,
    r: id
  }

  // if this action block already open, query points to closing it
  let active = ''
  if (id === actionId && !qs.m) {
    active = 'active '
    delete newQuery.r
  }
  delete newQuery.m
  let {pathname} = history.location 
  let DAd = pathname.includes('/users/manage/district-admins')
  let UserS = pathname.includes('/users/manage/schools')
  let SAd = pathname.includes('users/manage/school-admins/')
  let UserT = pathname.includes('/users/manage/teachers')
  let UserC = pathname.includes('/users/manage/classes/')
  let UserSt = pathname.includes('/users/manage/students')
  
  const link = queryString.stringify(newQuery)

  return (
    <span className='action-button edit-button '>
     { (!(DAd || UserS || SAd || UserT || UserC || UserSt )) &&   <Link to={`?${link}`}><Button  style={{"height":"40px","width":"40px","borderRadius":"50%" }} className={`${active} action-button edit`}><span style={{"position":"relative","left":"-4px","top":"-4px"}}>...</span></Button></Link>}
       {(DAd || UserS || SAd || UserT || UserC || UserSt) && <Link to={`?${link}`}><Button   style={{"height":"33px","width":"65px", "borderRadius": "150px"}} className={`${active} action-button edit`}><small>Edit</small></Button></Link>}
    </span>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionButton.js